module.exports = __webpack_public_path__ + "static/media/team13.66efdb6a.png";